export { default as GiftWhiteLineIcon } from './ic_gift_white_line.svg';
export { default as LoudSpeakerCircleIcon } from './ic_loud_speaker_circle.svg';
